export default __webpack_public_path__ + "static/media/menu-1-5.bfecc2fa.PNG";